// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__VIIu6","content":"GlobalSearch_content__1ppbP"};